/* eslint-disable */
function initMap() {
  var intrans = new google.maps.LatLng(41.9986787, -93.6348586);

  var map = new google.maps.Map(document.getElementById('mapContainer'), {
    zoom: 16,
    center: intrans,
  });

  var infoWindow = new google.maps.InfoWindow();
  infoWindow.setContent(createInfoWindowContent(intrans, map.getZoom()));
  infoWindow.setPosition(intrans);
  infoWindow.open(map);

  map.addListener('zoom_changed', function() {
    infoWindow.setContent(createInfoWindowContent(intrans, map.getZoom()));
    infoWindow.open(map);
  });
}

function createInfoWindowContent(latLng, zoom) {
  return [
    '<div class="contact__map_branding"></div>',
    '2711 South Loop Drive, Suite 4700',
    'Ames, IA 50010-8664'
  ].join('<br>');
}

$(document).ready(function() {
  if($('#mapContainer').length != 0) {
    initMap();
  }
});



// WEBPACK FOOTER //
// ./scripts/routes/contact.js